import { call, put } from "redux-saga/effects";
import Axios from "../../utils/axios";
import { STREAM_ACTIVITY_RECORD } from "../../state/events/constants";
import {
  recordStreamActivityDone,
  recordStreamActivityError
} from "../../state/events/actions";

function* recordStreamActivity({ activity }) {
  try {
    const url = STREAM_ACTIVITY_RECORD.replace(":eventId", activity.eventId);
    const result = yield call(Axios.core.post, url, {
      ...activity
    });
    yield put(recordStreamActivityDone(result?.data));
  } catch (e) {
    yield put(recordStreamActivityError(e?.response));
  }
}

export default recordStreamActivity;
